export const MUST_CHANGE_PASSWORD_STATUS_CODE = 461;
export const SSO_REQUIRED_STATUS_CODE = 462;
export const ELEVATED_ACCESS_REQUIRED_STATUS_CODE = 463;
export const UNIDENTIFIED_ERROR = 409;
export const CANCELED_BY_USER = "Request Cancelled by User";

/**
 * When impersonating a customer on a production dashboard, these paths will allow POST/PUT/PATCH/DELETE calls without confirming with the user
 *
 * NOTE: you will likely need to also update /dashboard/app/controllers/authenticated_controller.rb
 */
export const allowedImpersonationPathPatterns = [
  // Can't use /analytics/ because /analytics_report_settings/ in Manage App Group needs a confirm
  /analytics\/track/,
  /app_usage/,
  /apps_and_filters_preview/,
  /apps_and_filters_sentence/,
  /segments_and_filters_preview/,
  /conversion_filter_preview/,
  /campaign_schedule_summary/,
  /\/apps\/[0-9a-f]{24}\/charts\/uninstall/,
  // Load Campaigns digest filters
  /campaigns_data_filters/,
  // Load Canvas steps
  /canvas_steps/,
  /campaign_preview/,
  // Checking invalid attributes
  /^\/engagement\/[0-9a-f]{24}\/canvas\/[0-9a-f]{24}\/step\/[0-9a-f]{24}\/preview_path$/,
  /^\/engagement\/invalid_attribute_names/,
  // upload_image performs the actual upload, and library_image provides the metadata after this action has already been confirmed
  /gpt_assistant/,
  /dalle_assistant/,
  /library_image/,
  // Viewing a link in an email template
  /link_aliases\/upsert_lid/,
  /links_in_message/,
  /log/,
  /prediction_filters_preview/,
  // There are URLS with /apps/ that shouldn't be whitelisted but ones with /apps/.../push_credentials that should be in Manage App Group
  /push_credential/,
  /^\/engagement\/segment_preview\//,
  /^\/engagement\/user_directory_preview\/[0-9a-f]{24}/,
  /^\/engagement\/canvas\/items_blocking_steps_or_variations_deletion/,
  /^\/engagement\/user\/matcher/,
  /^\/engagement\/[0-9a-f]{24}\/feature_limitations/,
  /^\/engagement\/canvas_digest_state/,
  /segment_insights_stats/,
  /segments_and_filters_preview/,
  /segments_and_filters_sentence_array/,
  /filter_type/,
  /stop_impersonating/,
  // Email templating previews use POSTs and editing breaks when dealing with the wrapped Deferred
  /templated_preview/,
  /gpt_message_qa/,
  // Previewing a custom unsubscribe or opt-in page for an app group
  /template_test_page/,
  // A non-persisting in-app message preview endpoint
  /compiled_iam_custom_css/,
  // Used for analytics tracking
  /\/charts\/sessions/,
  /\/engagement\/campaign\/campaign_occurrences\//,
  // Used for a POSTWS request to show the Event History table in user search
  /^\/apps\/user_event_history\/[0-9a-f]{24}/,
  // POST used to retrieve selectors in impersonation
  /^\/engagement\/segments\/[0-9a-f]{24}\/download_selector/,
  // POST used to retrieve test user logs in impersonation
  /\/app_settings\/test_user_logs/,
  // Used for a POSTWS request to show query previews in SQL Segment Extensions
  /^\/engagement\/api\/segment_cohorts\/preview_sql/,
  // Used for recently visited tracking
  /recently_visited\/visit/,
  // Used for Engagement Reports
  /\/apps\/engagement_reports\/campaigns_by_tags/,
  /\/apps\/engagement_reports\/canvases_by_tags/,
  // brand guidelines
  /\/generative_ai\/brand_guidelines/,
  // Sage torchie
  /\/open_ai\/liquid_assistant/,
  // Accessibility scanning
  /\/scan_a11y$/,
  // BrazeAI Operator™
  /\/ai_agent\/openai_responses/,
  /\/ai_agent\/dynamic_prompts/,
  /\/ai_agent\/async_dynamic_prompts/,
  /\/ai_agent\/gemini_interactions/,
  /\/braze_docs\/fallback_search/,
  /\/braze_docs\/lookup/,
  /\/braze_docs\/search/,
  // Translation usage validation uses read-only POST for large payloads
  /\/apps\/multi_language_settings\/validate_translation_usage/,
  // Remote lookup endpoints use read-only POST
  /^\/remote_lookup\//,
  // Cortex Agent run_query is a read-only POST that queries data on behalf of the user
  /\/cortex_agent\/run_query/,
  // Channel dashboard data is a read-only POST used to fetch analytics data
  /^\/channel_dashboard\//,
];
